import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ImageLinks from "../../../assets/Images/ImagesLink";
import Footer from "../../../Footer";
import {
  convertUTCToTimezone,
  formatCurrencyCountry,
} from "../../../resources/internationalizationUtils";
import { useSelector } from "react-redux";

const TransactionInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const { data } = location.state || {};
  const handle_go_back = () => {
    navigate(-1);
  };
  const userDetails = useSelector((state) => state.app.user_details);
  const currency_code = userDetails?.currency || "DEFAULT";
  const tz = userDetails?.business_timezone || "DEFAULT";
  return (
    <div className="relative min-h-screen flex mt-6 flex-col">
      <div
        className="px-6 overflow-auto"
        style={{ height: `calc(100vh - 60px - env(safe-area-inset-bottom))` }}
      >
        <div className="flex items-center gap-2  pb-6" onClick={handle_go_back}>
          <img src={ImageLinks.chevron_right} className="w-[18px] h-[19px]" />
          <p className="font-custom text-sm font-semibold text-dark_black">
            {t("transaction_info")}
          </p>
        </div>
        <div className="bg-white rounded-xl bg-white shadow-[0px_0px_8px_rgba(166,166,166,0.25)] max-w-md pb-12 mt-4">
          <div className="relative flex justify-center  ">
            <img src={ImageLinks.ellips_success} className="w-[100%]" />
            <div className="w-12 h-12 flex items-center justify-center rounded-full absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 ">
              <img src={ImageLinks.check_tick_filled} />
            </div>
          </div>
          <div className="p-6 text-center mt-10 flex gap-1 flex-col">
            <p className="font-custom text-xl font-bold text-dark_black">
              {
                formatCurrencyCountry(data?.amount, currency_code)
                  .formatedAmount
              }
            </p>
            <p className="font-custom text-base font-medium text-dark_black">
              {t("transaction_id")}: {data?.transaction_id}
            </p>
          </div>
          <div className="px-7 flex flex-col gap-5">
            <div className="border-b border-light_gray"></div>
            <div className="flex justify-between">
              <p className="font-custom text-sm font-semibold text-dark_black">
                {t("transaction_type")}
              </p>
              <p className="font-custom text-sm font-semibold text-dark_black">
                {data?.transaction_type === 100
                  ? t("credit")
                  : t("debit")}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="font-custom text-sm font-semibold text-dark_black">
                {t("payment_method")}
              </p>
              <p className="font-custom text-sm font-semibold text-dark_black">
                {data?.payment_method}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="font-custom text-sm font-semibold text-dark_black">
                {t("payment_date")}
              </p>
              <p className="font-custom text-sm font-semibold text-dark_black">
                {convertUTCToTimezone(data?.timestamp, tz, "DD MMM, YYYY")}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="font-custom text-sm font-semibold text-dark_black">
                {t("payment_time")}
              </p>
              <p className="font-custom text-sm font-semibold text-dark_black">
                {convertUTCToTimezone(data?.timestamp, tz, "hh:mm A")}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="font-custom text-sm font-semibold text-dark_black">
                {t("transaction")}
              </p>
              <p className="font-custom text-sm font-semibold text-dark_black">
                {t("successful")}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer bottom={0} />
    </div>
  );
};

export default TransactionInfo;
